
export const DateTimeFormatCollection = {
  DateFormates: [
    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: `DD-MM-YYYY`,

      Value: "DD-MM-YYYY",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: `DD-MMM-YYYY`,

      Value: "DD-MMM-YYYY",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: `DD-MMMM-YYYY`,

      Value: "DD-MMMM-YYYY",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: `MM-DD-YYYY`,

      Value: "MM-DD-YYYY",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: `MMM-DD-YYYY`,

      Value: "MMM-DD-YYYY",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: `MMMM-DD-YYYY`,

      Value: "MMMM-DD-YYYY",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: `YYYY-MM-DD`,

      Value: "YYYY-MM-DD",
    },
  ],

  DateSeperators: [
    // {
    //   Disabled: false,

    //   Group: null,

    //   Selected: false,

    //   Text: "(Default)",

    //   Value: "",
    // },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "/",

      Value: "/",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "-",

      Value: "-",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: ".",

      Value: ".",
    },
  ],

  TimeFormates: [
    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "HH:mm",

      Value: "HH:mm",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "hh:mm tt",

      Value: "hh:mm A",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "H:mm",

      Value: "H:mm",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "h:mm tt",

      Value: "h:mm A",
    },
  ],

  FirstDayOfWeeks: [
    // {
    //   Disabled: false,

    //   Group: null,

    //   Selected: false,

    //   Text: "(Default)",

    //   Value: "-1",
    // },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "Sunday",

      Value: "0",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "Monday",

      Value: "1",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "Tuesday",

      Value: "2",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "Wednesday",

      Value: "3",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "Thursday",

      Value: "4",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "Friday",

      Value: "5",
    },

    {
      Disabled: false,

      Group: null,

      Selected: false,

      Text: "Saturday",

      Value: "6",
    },
  ],
};

export const ListDays = [
  {
    Text: "Sunday",
    Value: "Sunday",
  },
  {
    Text: "Monday",
    Value: "Monday",
  },
  {
    Text: "Tuesday",
    Value: "Tuesday",
  },
  {
    Text: "Wednesday",
    Value: "Wednesday",
  },
  {
    Text: "Thursday",
    Value: "Thursday",
  },
  {
    Text: "Friday",
    Value: "Friday",
  },
  {
    Text: "Saturday",
    Value: "Saturday",
  },
];
